"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var HeaderButton_1 = require("../HeaderButton");
var Icon_1 = require("../../../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var react_2 = require("@chakra-ui/react");
var HeaderLink_1 = require("../_shared/HeaderLink");
var NavLink_1 = require("../_shared/NavLink");
var NotificationsBadge_1 = require("./NotificationsBadge");
var NotificationsList_1 = require("./NotificationsList");
var colors_1 = require("../../colors");
var NotificationsMenu = function (_a) {
    var displayMode = _a.displayMode;
    var _b = (0, useHeaderProps_1.useHeaderProps)(), user = _b.user, notifications = _b.notifications, _js = _b._js, siteConfiguration = _b.siteConfiguration, colorSet = _b.colorSet;
    var _c = (0, react_1.useState)(false), isDropdownOpen = _c[0], setIsDropdownOpen = _c[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_2.useOutsideClick)({
        ref: ref,
        handler: function () { return setIsDropdownOpen(false); },
    });
    if (!user || (siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['in-page-notification-menu']) == false) {
        return null;
    }
    var encodedUserName = encodeURIComponent((user === null || user === void 0 ? void 0 : user.username) || '');
    if (!(notifications === null || notifications === void 0 ? void 0 : notifications.length)) {
        return displayMode === 'dropdown' ? (React.createElement(react_2.Box, { className: "header-notifications", "data-feature-id": "header_notifications" },
            React.createElement(HeaderLink_1.HeaderLink, { isRounded: true, "aria-label": _js('Notifications'), href: "/User/Notifications/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(encodedUserName), p: 4 },
                React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faBell, boxSize: 6 })))) : (React.createElement(NavLink_1.NavLink, { "aria-label": _js('Notifications'), href: "/User/Notifications/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(encodedUserName) }, _js('Notifications')));
    }
    return displayMode === 'dropdown' ? (React.createElement(react_2.Box, { className: "header-notifications", "data-feature-id": "header_notifications", ref: ref },
        React.createElement(react_2.Popover, { isOpen: isDropdownOpen, returnFocusOnClose: false, onClose: function () { return setIsDropdownOpen(false); } },
            React.createElement(react_2.PopoverTrigger, null,
                React.createElement(HeaderButton_1.HeaderButton, { isRounded: true, "aria-label": _js('Notifications'), p: 4, active: isDropdownOpen, onClick: function () { return setIsDropdownOpen(!isDropdownOpen); } },
                    React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faBell, boxSize: 6, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text }),
                    React.createElement(NotificationsBadge_1.NotificationsBadge, { left: "20px", top: "0px" }))),
            React.createElement(react_2.PopoverContent, { bg: colorSet === null || colorSet === void 0 ? void 0 : colorSet.background, w: "300px", maxH: "75vh", overflowY: "auto" },
                React.createElement(NotificationsList_1.NotificationsList, null))))) : (React.createElement(react_2.Accordion, { allowToggle: true },
        React.createElement(react_2.AccordionItem, { border: "none" },
            React.createElement(react_2.AccordionButton, { h: 12, _hover: { bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR }, _focus: { outline: 0, bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR }, color: colors_1.DEFAULT_TEXT_COLOR },
                React.createElement(react_2.Flex, { alignItems: "center", flex: 1, color: colors_1.DEFAULT_TEXT_COLOR },
                    React.createElement(NotificationsBadge_1.NotificationsBadge, { position: "static", mr: 2 }),
                    _js('Notifications')),
                React.createElement(react_2.AccordionIcon, null)),
            React.createElement(react_2.AccordionPanel, { pb: 4 },
                React.createElement(NotificationsList_1.NotificationsList, null)))));
};
exports.NotificationsMenu = NotificationsMenu;
